import { yupResolver } from "@hookform/resolvers/yup"
import PropTypes from "prop-types"
import { useForm, Controller } from "react-hook-form"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import { history } from "app-store-v2/index"
import Button from "components/ui/button"
import FloatInput from "components/ui/float-input"
import Image from "components/ui/image"
import Switch from "components/ui/switch"
import { IS_CA } from "helpers/application"
import withAuth from "hoc/account/with-auth"

import { HaveAccount, LogoContainer, Separator } from "./components"

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Please enter a valid email address.")
    .test("test-email", "Please enter a valid email address.", (value) =>
      isEmail(value || "")
    ),
  password: Yup.string()
    .required("Please enter your password.")
    .min(8, "Minimum 8 characters"),
})

const RegisterForm = ({
  doFacebookLogin,
  doSubmitRegistration,
  setModalContent,
}) => {
  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setError,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
      subscribe_vip: !IS_CA(),
    },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async (data) => {
    try {
      await new Promise((res, rej) => {
        doSubmitRegistration(data, {
          onError: (err) => rej(err),
          onSuccess: () => res(),
        })
      })
    } catch (err) {
      setError("root.error", { message: err })
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {errors?.root?.error && (
        <p className="text-error mb-8">{errors.root.error.message}</p>
      )}
      <Controller
        control={control}
        name="email"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            autoComplete="email"
            containerClassName="mb-16 text-left"
            error={error}
            id="email"
            label="Email"
            placeholder="Enter Your Email"
            {...field}
          />
        )}
        rules={{ required: true }}
      />
      <Controller
        control={control}
        name="password"
        render={({ field, fieldState: { error } }) => (
          <FloatInput
            autoComplete="new-password"
            containerClassName="mb-16 text-left"
            error={error}
            id="password"
            label="Password"
            placeholder="Enter Your Password"
            type="password"
            {...field}
          />
        )}
        rules={{ required: true }}
      />
      <div className="mb-16 text-left">
        <Controller
          control={control}
          name="subscribe_vip"
          render={({ field: { value, ...props }, fieldState: { error } }) => (
            <Switch checked={value} error={error} id="subscribe_vip" {...props}>
              <p className="text-grey-65 text-12 leading-15 tracking-tigher font-medium">
                Add me to the {sl.config.site_title} VIP list to receive
                exclusive deals, coupons and news by email.
              </p>
            </Switch>
          )}
        />
      </div>
      <Button
        className="mb-16 w-full"
        loading={isSubmitting}
        type="submit"
        variant="secondary"
      >
        Create My Account
      </Button>
      <Separator className="mb-16">or sign up using</Separator>
      <LogoContainer>
        <Button onClick={(e) => doFacebookLogin(e)}>
          <Image
            alt="Sign in with Facebook"
            className="w-auto"
            height="310"
            src={require("images/icons/facebook.png")}
            style={{ height: "30px" }}
            width="309"
          />
        </Button>
      </LogoContainer>
      <HaveAccount>
        Already have a Jewlr account?{" "}
        <Button
          className="text-14"
          onClick={() =>
            setModalContent
              ? setModalContent("#authenticate")
              : history.push("/signin")
          }
          text
          underline
          variant="secondary"
        >
          Sign In
        </Button>
      </HaveAccount>
    </form>
  )
}

RegisterForm.propTypes = {
  doFacebookLogin: PropTypes.func,
  doSubmitRegistration: PropTypes.func,
  setModalContent: PropTypes.func,
}

export default withAuth(RegisterForm)
